import { useCallback } from 'react';

import { ITranslateMethod } from '@core/js/hooks/i18n/types';

import { useDynamicTagList } from '@interlayer/js/app/hooks/useDynamicTagList';
import { DYNAMIC_TAG_NAMES } from '@interlayer/js/app/utils/constants';

export const useCheckCities = (t: ITranslateMethod) => {
    const blockedCities = useDynamicTagList({
        tagName: DYNAMIC_TAG_NAMES.blockedCities,
        defaultValue: 'Jersey, Isle of Man, Channel Islands, Alderney, Sark, Brecqhou, Jethou, Herm'
    });

    return useCallback((value = '') => {
        const city = value.trim().toLowerCase();

        if (blockedCities.some((item: string) => item === city)) {
            return [t('city.blocked')];
        }
    }, [blockedCities, t]);
};
